import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetLevelOneApi } from "../LevelOne/LevelOneAction";
import { GetLevelTwoWithLevelOneIDApi } from "../LevelTwo/LevelTwoAction";
import { AddLevelThreeApi } from "./LevelThreeAction";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from 'react-select';
import Swal from 'sweetalert';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddLevelThree = (props) => {
    const [levelOneId, setLevelOneId] = useState();
    const [levelOneName, setLevelOneName] = useState();
    const [levelTwoId, setLevelTwoId] = useState();
    const [levelTwoName, setLevelTwoName] = useState();
    const [levelThreeName, setLevelThreeName] = useState();
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    function SaveLevelThree() {
        props.AddLevelThreeApi({
            levelOneId: levelOneId,
            levelOneName: levelOneName,
            levelTwoId: levelTwoId,
            levelTwoName: levelTwoName,
            levelThreeName: levelThreeName,
        },
            handleVisible,
            handleDangerVisible
        );
        setLevelOneId("")
        setLevelTwoId("")
        setLevelThreeName("")
    }
    const handleVisible = (msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    }
    const handleDangerVisible = (error) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: error,
            icon: "error",
            button: "Ok",
        });
    }


    const handleChangeLevelOne = (selectedOption) => {
        setLevelOneId(selectedOption.value);
        setLevelOneName(selectedOption.label);
        props.GetLevelTwoWithLevelOneIDApi(selectedOption.value)
    };
    const getLevelOneList = props.levelOneList?.data?.length ? props.levelOneList.data.map(x => ({
        value: x._id,
        label: `${x.key} - ${x.name}`,
    })) : [];

    const handleChangeLevelTwo = (selectedOption) => {
        setLevelTwoId(selectedOption.value);
        setLevelTwoName(selectedOption.label);
    };
    const getLevelTwoList = props.levelTwoWithLevelOneIdList?.length ? props.levelTwoWithLevelOneIdList.map(x => ({
        value: x._id,
        label: `${x.allKey} - ${x.levelTwoName}`,
    })) : [];

    useEffect(() => {
        props.GetLevelOneApi();
        props.setHeading("Add Level Three");
    }, []);

    return (
        <>
            {props.isFetchingLevelOne || props.isAddingLevelThree ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 1 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 1"
                                    onChange={handleChangeLevelOne}
                                    options={getLevelOneList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b> Select Level 2 *</b></Form.Label>
                                <Select
                                    placeholder="Select Level 2"
                                    onChange={handleChangeLevelTwo}
                                    options={getLevelTwoList}
                                    isDisabled={_.isEmpty(levelOneId)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Level 3 Name *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Level 3 Name"
                                    onChange={(e) => setLevelThreeName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(levelOneId) || _.isEmpty(levelTwoId) || _.isEmpty(levelThreeName) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveLevelThree}> SAVE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        GetLevelOneApi: () => dispatch(GetLevelOneApi()),
        GetLevelTwoWithLevelOneIDApi: (levelOneId) => dispatch(GetLevelTwoWithLevelOneIDApi(levelOneId)),
        AddLevelThreeApi: (data, handleVisible, handleDangerVisible) => dispatch(AddLevelThreeApi(data, handleVisible, handleDangerVisible)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingLevelThree: state.LevelThreeReducer.isAddingLevelThree,
    isFetchingLevelOne: state.LevelOneReducer.isFetchingLevelOne,
    levelOneList: state.LevelOneReducer.levelOneList,
    levelTwoWithLevelOneIdList: state.LevelTwoReducer.levelTwoWithLevelOneIdList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddLevelThree);